







































import _ from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { ArrayDataGetComponent } from '@/tcw/components/DataGetComponent'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import * as ApiPath from '@/tcw/constant/ApiPath'
import KoutsuhiPatternCard from '@/components/pattern/molecules/KoutsuhiPatternCard.vue'
import { TcwFormID } from '@/tcw/domain/types'
import { TCWServerValidationError } from '@/plugins/TCWBaseError'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'

@Component({
  components: { TcwLayoutBasicTemplate, KoutsuhiPatternCard }
})
export default class KoutsuhiPatternCardList extends Mixins(
  ArrayDataGetComponent,
  DataUpdateComponent
) {
  private patternList: ApiGeneralObjectArrayPayload = []
  private confirm = false
  private deleteId: TcwFormID = null

  get apiPath(): string {
    return ApiPath.Paths.KoutsuhiPatternList.get
  }
  protected responseInitWebApi(response: ApiGeneralObjectArrayPayload): void {
    if (_.isArray(response)) {
      this.patternList = response
    }
  }

  protected addPattern(): void {
    this.$router.push('/pattern/koutsuhi/')
  }
  protected openConfirm(patternId: TcwFormID): void {
    this.deleteId = patternId
    this.confirm = true
  }

  protected async validate(): Promise<void> {
    if (this.deleteId === null) {
      return Promise.reject('削除する交通費パターンを選択してください')
    } else {
      return Promise.resolve()
    }
  }

  protected async execSaveMain(): Promise<void> {
    // API 構築
    const apiPath = ApiPath.Paths.KoutsuhiPatternEdit.delete
    const id = this.deleteId ? this.deleteId : ''
    const path = ApiPath.buildPath(apiPath, { id })

    // 削除実行交通費パターンの削除に失敗しました
    await this.getWebApi().call(path, 'DELETE')
  }

  protected serverValidationErrorProc(e: TCWServerValidationError): void {
    const message = `${e.message}。使用しているパターン：${e.getMessageDetail()}`
    this.$tcw.message({
      type: 'error',
      title: '削除に失敗しました',
      message: message
    })
    console.log(e.invalidInfo)
  }

  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '交通費パターンを削除しました'
    })

    // 再読み込み
    await this.init()
  }
  protected async endProc(): Promise<void> {
    this.confirm = false
  }
}
